import { render, staticRenderFns } from "./createdContacts.vue?vue&type=template&id=478bc305&scoped=true"
import script from "./createdContacts.vue?vue&type=script&lang=js"
export * from "./createdContacts.vue?vue&type=script&lang=js"
import style0 from "./createdContacts.vue?vue&type=style&index=0&id=478bc305&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478bc305",
  null
  
)

export default component.exports